import { render, staticRenderFns } from "./food-item-search.vue?vue&type=template&id=c1cc78ac&"
import script from "./food-item-search.vue?vue&type=script&lang=js&"
export * from "./food-item-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports